import { Typography } from "antd";
import HeaderLogo from "./components/HeaderLogo";
import VerificationMethods from "./components/VerificationMethods";
import "./portalResponsive.css";

const { Title, Paragraph } = Typography;

const HederaVerificationPortal = () => {
  return (
    <div
      style={{
        backgroundColor: "rgba(239, 246, 255, .6)",
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      <HeaderLogo />
      <div className="portal-content">
        {/* Page Heading */}
        <div style={{ textAlign: "center" }}>
          <Title
            level={2}
            className="portal-heading"
            style={{ fontSize: "30px" }}
          >
            Verify Your Test Report
          </Title>
          <Paragraph
            className="portal-subheading"
            style={{ fontSize: 16, color: "#555" }}
          >
            Choose your preferred verification method to access and validate
            your food safety test results.
          </Paragraph>
        </div>
        <div className="portal-box">
          <Title level={3} style={{ fontSize: "24px", marginBottom: 8 }}>
            Choose Your Verification Method
          </Title>

          <Paragraph style={{ fontSize: 16, color: "#5f6c74", margin: 0 }}>
            Select how you'd like to verify your FoodLabz report. Both methods
            provide complete blockchain verification.
          </Paragraph>
        </div>

        {/* ---- VERIFICATION METHODS BELOW THE BOX ---- */}
        <div style={{ marginTop: 32, boxSizing: "border-box", width: "100%" }}>
          <VerificationMethods />
        </div>

        {/* ---- FOOTER ---- */}
        <div className="portal-footer">
          <h3>Need assistance?</h3>
          <Paragraph style={{ margin: 0 }}>
            Contact our support team at{" "}
            <a href="mailto:support@agnext.in">support@agnext.in</a>
          </Paragraph>
          <Paragraph style={{ margin: 0 }}>or call +91-80 4718 5818</Paragraph>
        </div>
      </div>
    </div>
  );
};

export default HederaVerificationPortal;
